import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <span className="text-xs text-foreground-500 uppercase tracking-widest">分类</span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">精选分类导航</h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.slice(0, 5).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-lg p-5 md:p-6 bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer min-h-[140px] flex flex-col justify-between"
            >
              <div>
                <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center mb-3">
                  <span className="font-heading text-secondary-600 text-lg">{cat.name.charAt(0)}</span>
                </div>
                <h3 className="font-heading text-base md:text-lg text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                  {cat.name}
                </h3>
              </div>
              <p className="text-xs text-foreground-500 mt-2">{cat.count.toLocaleString()} 部作品</p>
            </Link>
          ))}
          {categories.slice(5, 10).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-lg p-5 md:p-6 bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer min-h-[140px] flex flex-col justify-between"
            >
              <div>
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-3">
                  <span className="font-heading text-accent-600 text-lg">{cat.name.charAt(0)}</span>
                </div>
                <h3 className="font-heading text-base md:text-lg text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                  {cat.name}
                </h3>
              </div>
              <p className="text-xs text-foreground-500 mt-2">{cat.count.toLocaleString()} 部作品</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}